// Module
var code = "<p>Attendance: Do you know that we have great philosophy here in India?</p> <p>T: What kind of philosophy do you mean by the great philosophy?</p> <p>A: It is Veranta philosophy.</p> <p>T: Then, could you show me the evidences that Veranta philosophy is helping human society in some ways.</p> <p>A: …</p> <p></p>";
// Exports
module.exports = code;